/* eslint-disable */
import { createContext, useState, useEffect } from 'react'
import { ThemeProvider, createTheme, Theme } from '@mui/material/styles'
import { colors, CssBaseline } from '@mui/material'

export const ThemeContext = createContext({})
export const ThemeSelector = createContext(null)

interface DefaultState {
    theme: Theme
}

export const ThemeBuilder = ({ children }) => {
    const { green, grey } = colors

    const defaultTheme = createTheme({
        palette: {
            mode: 'dark',
            primary: {
                light: '#8cc63f',
                main: '#8cc63f',
                dark: '#8cc63f',
                contrastText: '#fff',
            },
            secondary: {
                light: '#ff7961',
                main: '#333',
                dark: '#333',
                contrastText: '#fff',
            },
            action: {
                hover: '#8cc63f',
                active: '#8cc63f',
            },
            background: {
                paper: grey[900],
                default: '#212121',
            },
        },
    })
    const defaultState: DefaultState = {
        theme: defaultTheme,
    }
    const [state, setNewState] = useState(defaultState)
    const { theme } = state
    const setState = (newState: object) =>
        setNewState({ ...state, ...newState })

    return (
        <ThemeContext.Provider value={theme}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </ThemeContext.Provider>
    )
}
